const RAW_API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '')

const resolveApiBase = () => {
  if (!RAW_API_BASE) return ''
  if (typeof window === 'undefined') return RAW_API_BASE

  try {
    const url = new URL(RAW_API_BASE)
    if (window.location.hostname === 'localhost' && url.protocol === 'http:' && url.hostname !== 'localhost') {
      url.hostname = window.location.hostname
    }
    return url.toString().replace(/\/+$/, '')
  } catch {
    return RAW_API_BASE
  }
}

export const API_BASE = resolveApiBase()

// univerzálne pre bežné endpointy (/auth, /users, /wallet, ...)
export const withBase = (pathOrUrl = '') => {
  if (!pathOrUrl) return API_BASE
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl
  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`
  return `${API_BASE}${path}`
}

// špeciálne pre ledger, ktorý má /api prefix
export const withApiBase = (pathOrUrl = '') => {
  if (!pathOrUrl) return `${API_BASE}/api`
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl
  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`
  return `${API_BASE}/api${path}`
}
